export function register() {
  if ("serviceWorker" in navigator) {
    // Register immediately to catch tile requests as early as possible
    const swUrl = `/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then(() => {
        console.log("[SW] Service worker registered successfully");
      })
      .catch((error) => {
        console.error("[SW] Service worker registration failed:", error);
      });
  }
}
